import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private apiUrl = environment.apiUrl + 'Permission';

    constructor(private http: HttpClient) { }


    getUserPermissions(scope: any): Observable<any> {
        console.log("SCOPE: ", scope);
        return this.http.get<any>(`${this.apiUrl}/GetUserPermissions/`+ scope);
    }


     
}
